export const ROOMS_LABELS = {
  arena: { name: "Arena", npc: "Arena Master" },
  scrap_yard: { name: "Scrap Yard", npc: "Rusty" },
  neon_district: { name: "Neon District", npc: "Lux" },
  quests: { name: "Quest Terminal", npc: "Mission Control" },
  drop_ship: { name: "Drop Ship", npc: "Security Terminal" },
};
